<template>
  <Modal
    confirm-variant="primary-ghost"
    no-cancel
    :tracking="{
      action: 'state_switch',
      topicKey: 'incorrect_state_detected',
    }"
    @confirm="emit('confirm')"
  >
    <template #headline>{{ $t('stateswitch.modal.headline') }}</template>

    <i18n-t keypath="stateswitch.modal.text" scope="global" tag="p">
      <template #state>
        <strong>
          {{ $t(`licensedterritory.${licensedTerritory}`) }}
        </strong>
      </template>
    </i18n-t>

    <Illustration class="illustration mt-200" name="location-redirect" />

    <template #confirm>{{ $t('stateswitch.modal.confirm') }}</template>
  </Modal>
</template>

<script lang="ts" setup>
const { licensedTerritory } = useStateSwitch()

const emit = defineEmits<{ (e: 'confirm'): void }>()
</script>

<style lang="scss" scoped>
.illustration {
  width: 24rem;
}
</style>
